<template>
  <div id="app" class="app">
	<!-- header -->
	<div class="app.header">
		<div class="intellectual-home.block">
			<intellectual-header :showSearch="true" @showConsultationEvent="showConsultationEvent"></intellectual-header>
		</div>
	</div>
    <router-view />
		<commonBubble @showTipsEvent="showTipsEvent"/>
		<tips-modal :tipsShow="tipsShow" @closeTipsEvent="closeTipsEvent"></tips-modal>
		<consultation-modal :consultationShow="consultationShow" @closeConsultationEvent="closeConsultationEvent"></consultation-modal>
  </div>
</template>
<script>
	import IntellectualHeader from './components/intellectual-header.vue'
	import commonBubble from "./components/common-bubble";
	import TipsModal from './components/tips-modal.vue'
	import ConsultationModal from './components/consultation-modal.vue'
export default {
	
	data() {
		return {
			tipsShow:false,
			consultationShow:false,
		}
	},
	components: {
		commonBubble,
		TipsModal,
		IntellectualHeader,
		ConsultationModal
	},
  	mounted(){
  	//计算缩放
  	var phoneScale = parseInt(window.screen.width)/1250;
  	document.write('<meta name="viewport" content="width=1250, initial-scale = '+phoneScale+', maximum-scale = '+phoneScale+', target-densitydpi=device-dpi">');
	
  },
  methods:{
	  closeTipsEvent(val){
		  this.tipsShow = val
	  },
	  showTipsEvent(val){
		   this.tipsShow = val
	  },
	  showConsultationEvent(val){
	  	this.consultationShow = val
	  },
	  closeConsultationEvent(val){
	  	this.consultationShow = val
	  },
  }
};
</script>

<style lang="scss">
	@include tweak(navigation-line){
		width: 100%;
		height: 2px;
		background: #2278FC;
		min-width: 1250px;
	}
	@include component(app){
		@include part(header){
			background: #fff;
		}
	}
</style>
